import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './resources/en.json';
import hi from './resources/hindi.json';
import hien from './resources/hinglish.json';

const language = window.localStorage.getItem('language');

const resources = {
  en: {
    translation: en,
  },
  hi: {
    translation: hi,
  },
  hien: {
    translation: hien,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    resources,
    lng: language || 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
